import React from "react";

// What the Dashboard, Requests, Revenue and Trending tabs show in place of
// their numbers until the server answers: "Loading…", or, when the read
// failed, a plain line and Retry (the Fans tab's pattern). The numbers are
// never shown for a choice they don't answer.
export default function StatsPending({ failed, onRetry }: { failed: boolean; onRetry: () => void }) {
  if (!failed) return <p className="muted-text adm-center adm-p-30">Loading…</p>;
  return (
    <div className="adm-center adm-p-30" role="alert">
      <p className="muted-text">Couldn't load these numbers.</p>
      <button type="button" className="adm-btn-light" onClick={onRetry}>
        Retry
      </button>
    </div>
  );
}
